import styled, { css } from 'styled-components';

import Drawer, { DrawerBody, DrawerTitle } from '@components/Drawer/next';

export const StyledDrawer = styled(Drawer)<{ booker?: boolean }>`
  ${DrawerBody} {
    padding: ${({ booker }) => (booker ? '0px 10px ' : '0px 15px')};
    overflow: scroll;
    background-color: ${({ theme }) => theme.palette.white} !important;
  }

  ${DrawerTitle} {
    font-weight: 600;
    width: max-content;
  }
`;

export const ResponsiveSearchDrawerItemContent = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(75, 75, 75, 0.2);
  padding: 16px 0px;
  height: fit-content;

  &.border-bottom-hidden {
    border-bottom: none;
  }
`;

export const ResponsiveSearchDrawerItemText = styled.div`
  flex: 1;
`;

export const ResponsiveSearchDrawerItemTitle = styled.span<{
  isFilled?: boolean;
}>`
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: ${({ isFilled }) => (isFilled ? 0.5 : 1)};
`;

export const ResponsiveSearchDrawerItemSubtitle = styled.span<{
  isEmpty: boolean;
}>`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
  font-weight: 600;
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      opacity: 0.5;
    `}
`;
